import React from 'react';
import PropTypes from 'prop-types';
import css from './actions-list.scss';
import SvgIcon from '../svg-icon/svg-icon';

const ActionsList = (props) => {
  const { options, shouldOpenUp, isWide, isOpen } = props;

  function renderList() {
    const listClassName = `${css.actionsList} ${
      shouldOpenUp ? css['actionsList--flow-up'] : ''
    } ${isWide ? css['actionsList--wide'] : ''}`;
    return (
      <ul
        className={listClassName}
        data-testid={isOpen ? 'action-list--open' : 'action-list--closed'}
      >
        {((options?.length && options) || []).map((option, index) => (
          <li
            className={option.disabled ? css['actionsList--disabled'] : ''}
            key={`${option.text}_${option.subtext}`}
          >
            {option.icon && <SvgIcon icon={option.icon} />}
            <span
              className={css.actionsListText}
              data-testid={`actions-list-option--${index}`}
              role="button"
              tabIndex="0"
              onClick={option.disabled ? undefined : option.onClick}
            >
              {option?.text}
              {option.subtext && (
                <>
                  <br />
                  <span className={css['actionsList__text--small']}>
                    {option.subtext}
                  </span>
                </>
              )}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  return <>{isOpen ? renderList() : null}</>;
};

ActionsList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  isWide: PropTypes.bool,
  shouldOpenUp: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired
};

ActionsList.defaultProps = {
  shouldOpenUp: false
};

export default ActionsList;



// WEBPACK FOOTER //
// ./components/actions-list/index.js